// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2DGZB","unreadBadge":"styles_unreadBadge__BzPqb","modalContent":"styles_modalContent__3i25E","modal":"styles_modal__1tAiO"};